import {
  INSTRUMENTAL_AUTO_THRESHOLD,
  INSTRUMENTAL_RECOMMENDED_THRESHOLD,
  REVERB_AUTO_THRESHOLD,
  REVERB_RECOMMENDED_THRESHOLD,
} from "@/constants/audioQuality";
import {
  IsolationBadges,
  IsolationState,
} from "@/types/defs/audioQuality/isolationBadges";

const pickIsolationSetting = (
  passesAuto: boolean,
  passesRecommended: boolean
): IsolationState => {
  switch (true) {
    case passesAuto:
      return "autoApplied";
    case passesRecommended:
      return "recommended";
    default:
      return "off";
  }
};

// All checks must meet the threshold for a flag to be set (strictest file wins).
export const getAudioIsolationRecommendations = (
  audioQualityRatios: ({
    instrumentRatio: number;
    reverbRatio: number;
  } | null)[]
): IsolationBadges => {
  const completedChecks = audioQualityRatios.filter((check) => check !== null);

  if (completedChecks.length === 0) {
    return { instrumental: "off", reverb: "off" };
  }

  const instrumentalAuto = completedChecks.every(
    (check) => check.instrumentRatio >= INSTRUMENTAL_AUTO_THRESHOLD
  );
  const instrumentalRecommended = completedChecks.every(
    (check) => check.instrumentRatio >= INSTRUMENTAL_RECOMMENDED_THRESHOLD
  );
  // If instrumental is detected we also recommend reverb removal.
  const reverbAuto = completedChecks.every(
    (check) =>
      check.reverbRatio >= REVERB_AUTO_THRESHOLD ||
      check.instrumentRatio >= INSTRUMENTAL_AUTO_THRESHOLD
  );
  const reverbRecommended = completedChecks.every(
    (check) =>
      check.reverbRatio >= REVERB_RECOMMENDED_THRESHOLD ||
      check.instrumentRatio >= INSTRUMENTAL_RECOMMENDED_THRESHOLD
  );

  return {
    instrumental: pickIsolationSetting(
      instrumentalAuto,
      instrumentalRecommended
    ),
    reverb: pickIsolationSetting(reverbAuto, reverbRecommended),
  };
};
